import { type FC } from 'react'

import { ErxHub } from '../../../erx-hub'

import { ErxBonusLandingPageFaqV1 } from './components/ErxBonusLandingPageFaq/ErxBonusLandingPageFaq'
import { ErxBonusLandingPageHeroHeaderV1 } from './components/ErxBonusLandingPageHeroHeader/ErxBonusLandingPageHeroHeader'
import { ErxBonusLandingPageHowBonusIsCalculatedV1 } from './components/ErxBonusLandingPageHowBonusIsCalculated/ErxBonusLandingPageHowBonusIsCalculated'
import { ErxBonusLandingPageHowToV1 } from './components/ErxBonusLandingPageHowTo/ErxBonusLandingPageHowTo'
import { ErxBonusLandingPageMarketingBannerV1 } from './components/ErxBonusLandingPageMarketingBanner/ErxBonusLandingPageMarketingBanner'
import { ErxBonusLandingPageTypesOfPrescriptionsV1 } from './components/ErxBonusLandingPageTypesOfPrescriptions/ErxBonusLandingPageTypesOfPrescriptions'

export const ErxBonusLpV1: FC = () => {
  return (
    <>
      <ErxBonusLandingPageHeroHeaderV1 />
      <ErxBonusLandingPageHowToV1 />
      <div className="bg-light-primary-medium">
        <div className="container py-8 tablet:py-12">
          <ErxBonusLandingPageHowBonusIsCalculatedV1 />
          <ErxBonusLandingPageMarketingBannerV1 />
        </div>
      </div>
      <div className="container px-4">
        <ErxBonusLandingPageTypesOfPrescriptionsV1 />
        <ErxBonusLandingPageFaqV1 />
        <ErxHub />
      </div>
    </>
  )
}
